import React, { useState } from 'react'
import Aspect169Icon from 'assets/svgr-icons/Aspect_Ratio_16_9_Dropdown.svg'
import Aspect916Icon from 'assets/svgr-icons/Aspect_Ratio_9_16_Dropdown.svg'
import ArrowDownIcon from 'assets/svgr-icons/Arrow_Down.svg'
import * as Styled from './styled'
import { ASPECT_RATIO_PER_TYPE } from 'containers/SubSidebar/AiImageContent/consts'
import { getAspectRatioOptions } from './consts'
import AspectRatioOption from './AspectRatioOption'
import { useAspectRatioSwitch } from 'hooks/useAspectRatioSwitch'
import { useAspectRatioWarning } from 'hooks/useAspectRatioWarning'
import useBackdropClick from 'hooks/useBackdropClick'
import AspectRatioWarningPopup from 'common-components/AspectRatioWarningPopup'

const AspectRatioSelect: React.FC = () => {
  const { aspectRatioString, canSwitch } = useAspectRatioSwitch()
  const {
    handleAspectRatioClick,
    showWarning,
    pendingSelection,
    handleConfirmSwitch,
    handleCancelSwitch
  } = useAspectRatioWarning()
  const [open, setOpen] = useState(false)
  const wrapperRef = useBackdropClick<HTMLDivElement>(() => {
    if (open) {
      setOpen(false)
    }
  })

  const options = getAspectRatioOptions().map(opt => ({
    ...opt,
    icon: <opt.icon />
  }))

  const onSelect = (key: 'landscape' | 'portrait') => {
    if (!canSwitch) {
      setOpen(false)
      return
    }

    const currentKey = options.find(opt => opt.ratio === aspectRatioString)?.key
    if (key === currentKey) {
      setOpen(false)
      return
    }

    handleAspectRatioClick(key)
    setOpen(false)
  }

  const currentIcon =
    aspectRatioString === ASPECT_RATIO_PER_TYPE.portrait ? (
      <Aspect916Icon />
    ) : (
      <Aspect169Icon />
    )

  return (
    <>
      <Styled.Wrapper ref={wrapperRef}>
        <Styled.Trigger
          $isOpen={open}
          $disabled={!canSwitch}
          onClick={() => canSwitch && setOpen(v => !v)}
        >
          <Styled.Left>
            <Styled.IconBox>{currentIcon}</Styled.IconBox>
            <Styled.Num>{aspectRatioString}</Styled.Num>
          </Styled.Left>
          <Styled.ArrowWrapper $isOpen={open}>
            <ArrowDownIcon />
          </Styled.ArrowWrapper>
        </Styled.Trigger>
        {open && (
          <Styled.Panel>
            {options.map(opt => (
              <AspectRatioOption
                key={opt.key}
                label={opt.label}
                ratio={opt.ratio}
                icon={opt.icon}
                isSelected={aspectRatioString === opt.ratio}
                onClick={() => onSelect(opt.key)}
              />
            ))}
          </Styled.Panel>
        )}
      </Styled.Wrapper>

      <AspectRatioWarningPopup
        isOpen={showWarning}
        pendingSelection={pendingSelection}
        onConfirm={handleConfirmSwitch}
        onCancel={handleCancelSwitch}
      />
    </>
  )
}

export default AspectRatioSelect
